module.exports = __webpack_public_path__ + "img/3_66.26d56d20.png";